import React, {CSSProperties, ReactElement} from "react";
import classes from './TextField.module.scss'
import clsx from "clsx";

interface Props {
	error?: boolean,
	helperText?: string,
	value?: string,
	onChange?: (e: React.ChangeEvent<HTMLElement>) => void,
	success?: boolean,
	placeholder?: string,
	multiline?: boolean,
	style?: CSSProperties,
	className?: string,
	name?: string
}

const TextField = (props: Props): ReactElement => {
	return (
		<div
			className={clsx(
				classes.root,
				props.error && classes.error,
				props.success && classes.success,
				props.className
			)}>
			{props.multiline ?
				<textarea
					name={props.name}
					value={props.value}
					placeholder={props.placeholder}
					onChange={props.onChange}
					style={props.style}
					className={clsx(
						classes.input
					)}
				/>
				:
				<input
					value={props.value}
					placeholder={props.placeholder}
					onChange={props.onChange}
					name={props.name}
					style={props.style}
					className={clsx(
						classes.input
					)}
				/>
			}
			<p className={classes.helperText}>{props.helperText}</p>
		</div>
	)
}

export default TextField